import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';

export interface UrlFeatureFlagConfig {
  paramName: string;
  expectedValue: string;
}

@Injectable({
  providedIn: 'root',
})
export class UrlFeatureFlagService {
  private readonly _route = inject(ActivatedRoute);

  isUrlFeatureFlagEnabled(config: UrlFeatureFlagConfig): Observable<boolean> {
    return this._route.queryParams.pipe(
      map((queryParams) => {
        const paramValue = queryParams[config.paramName];
        return paramValue === config.expectedValue;
      }),
    );
  }

  isUrlFeatureFlagEnabledSync(config: UrlFeatureFlagConfig): boolean {
    const queryParams = this._route.snapshot.queryParams;
    const paramValue = queryParams[config.paramName];
    return paramValue === config.expectedValue;
  }
}
